import { Component, EventEmitter, Input, Output } from '@angular/core';
import { InventoryModel } from '../../../../models/inventory.model';
import { CONSTANTS } from '../../../../constants';
import { Router } from '@angular/router';
import { PoTagModule, PoTagType, PoWidgetModule } from '@po-ui/ng-components';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-inventory-header-card',
  imports: [PoWidgetModule, PoTagModule, CommonModule],
  templateUrl: './inventory-header-card.component.html',
  styleUrl: './inventory-header-card.component.css'
})
export class InventoryHeaderCardComponent {
  @Input() inventories!: InventoryModel[];
  @Output() onOpenInventoryCount = new EventEmitter<InventoryModel>();
  statusLabels = CONSTANTS.INVENTORY_STATUS;
  colorsStatusLabels = CONSTANTS.INVENTORY_COUNT_STATUS_COLORS;

  constructor(private router: Router) { }

  openDetail(item: InventoryModel) {
    this.onOpenInventoryCount.emit(item);
  }

  getStatusLabel(status: number): string {
    return (CONSTANTS.INVENTORY_STATUS as Record<number, string>)[status] || 'Desconhecido';
  }

  getStatusColor(value: number): PoTagType {
    return CONSTANTS.INVENTORY_COUNT_STATUS_COLORS[value as keyof typeof CONSTANTS.INVENTORY_COUNT_STATUS_COLORS] ?? PoTagType.Neutral;
  }
}
